import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiResult } from '../models/ApiResult';
import { ResultadoImportModel } from '../models/ErroresImportModel';


@Injectable()
export class ImportarService {

  myAppUrl: string;
  //archivoasubir: File;

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  // getArchivo(archivos: File): Observable<ApiResult>{
  //   const headers = new HttpHeaders({
  //     'security-token': 'mytoken'
  //   });

  //   //this.archivoasubir = archivos.item(0);
  //   let formData = new FormData();
  //   formData.append("file", archivos, archivos.name);

  //   return this.http.post<ApiResult>(this.myAppUrl + 'api/Importacion/', formData, { headers: headers }) //, responseType: 'blob'
  // }

  uploadArchivo(archivo: File, urlTwo: string = 'api/Importacion/', idAux: string = null): Observable<ResultadoImportModel>{


    let formData = new FormData();
    formData.set("file", archivo, archivo.name);
    //formData.append("file", archivo, archivo.name);

    if(idAux == null) {
      return this.http.post<ResultadoImportModel>(this.myAppUrl + urlTwo, formData) //, responseType: 'blob'
    } else {
      return this.http.post<ResultadoImportModel>(this.myAppUrl + urlTwo+"/"+idAux, formData)
    }

  }
}
